import { useTranslation } from 'react-i18next'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { BlogPost } from '@entities/Blog'

import { URL_BLOG } from '@shared/contants'
import ArticleCard from '@shared/ui/aritcle-card'
import ArrowLink from '@shared/ui/arrow-link'
import CardSkeleton from '@shared/ui/card-skeleton'

import styles from './styles.module.scss'

function BlogLoading () {
  return (
    <div className={styles.root__grid}>
      {Array.from({ length: 3 }).map((_, i) => (
        <CardSkeleton className={styles.root__item} key={i} />
      ))}
    </div>
  )
}

type BlogPreviewProps = {
  title?: string;
  articles?: BlogPost[]
  loading?: boolean;
  useBigSize?: boolean;
  isCarousel?: boolean;
  moreLink?: string;
};

export default function BlogPreview ({
  title,
  articles,
  loading,
  //useBigSize = true,
  moreLink = URL_BLOG,
}: BlogPreviewProps) {
  const { t: tc } = useTranslation('common')
  const { t: tb } = useTranslation('blog')

  return (
    <div className={styles.root}>
      <div className={styles.root__top}>
        <h2 className={styles.root__title}>{ title ?? tb('title')}</h2>
        <ArrowLink to={moreLink} text={tc('more')} />
      </div>

      {loading ? (
        <BlogLoading />
      ) : (
        <Swiper
          className={styles.root__slider}
          slidesPerView="auto"
          spaceBetween={16}
          navigation
          modules={[ Navigation ]}
        >
          {articles?.map((item, idx) => (
            <SwiperSlide className={styles.root__slide} key={idx}>
              <ArticleCard
                className={styles.root__item}
                data={item}
                isCarouselItem
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  )
}
